import { createAction } from '@reduxjs/toolkit';
import karmaEarnOfferSlice from './slice';

export const fetchKarmaEarnOffer = createAction('karmaEarnOffer/fetchKarmaEarnOffer');

export const { receiveItem, reset } = karmaEarnOfferSlice.actions;
